import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=a2e1a78c&scoped=true&"
import script from "./BaseCarousel.vue?vue&type=script&lang=js&"
export * from "./BaseCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BaseCarousel.vue?vue&type=style&index=0&id=a2e1a78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e1a78c",
  null
  
)

export default component.exports